var ExchangeDesiredDateScreen = (function ($) {

    ExchangeDesiredDateScreen = function (options) {
        var that = this;

        options = options || {};

        // CONST
        that.order_hash = options['order_hash'] || null;
        that.order_passenger_hash = options['order_passenger_hash'] || null;
        that.modals = options['modals'] || {};
        that.locales = options['locales'] || {};
        that.attribute = {
            disabled: 'disabled'
        };
        that.class = {
            hidden: 'hidden',
            error: 'error'
        };
        that.selectors = {
            exchange_form: '.js-exchange-form',
            departure_city: '.js-departure-city',
            departure_airport: '.js-departure-airport',
            arrival_city: '.js-arrival-city',
            arrival_airport: '.js-arrival-airport',
            trip_arrows_icon: '.js-trip-arrows-icon',
            trip_arrow_icon: '.js-trip-arrow-icon',
            input_date_desired_segment_wrapper: '.js-input-date-desired-segment-wrapper',
            input_date_desired_segment: '.js-input-date-desired-segment',
            calendar_wrapper: '.js-calendar-wrapper'
        };

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$exchange_form = $(that.selectors.exchange_form);
        that.$departure_city = that.$wrapper.find(that.selectors.departure_city);
        that.$departure_airport = that.$wrapper.find(that.selectors.departure_airport);
        that.$arrival_city = that.$wrapper.find(that.selectors.arrival_city);
        that.$arrival_airport = that.$wrapper.find(that.selectors.arrival_airport);
        that.$trip_arrows_icon = that.$wrapper.find(that.selectors.trip_arrows_icon);
        that.$trip_arrow_icon = that.$wrapper.find(that.selectors.trip_arrow_icon);
        that.$input_date_desired_segment_wrapper = that.$wrapper.find(that.selectors.input_date_desired_segment_wrapper);
        that.$input_date_desired_segment = that.$input_date_desired_segment_wrapper.find(that.selectors.input_date_desired_segment);
        that.$calendar_wrapper = that.$input_date_desired_segment_wrapper.siblings(that.selectors.calendar_wrapper);

        // DYNAMIC VARS
        that.calendar_data = null;
        that.ui_calendar_input = null;
        that.direction = null;
        that.request_started = false;
        that.first_available_exchange_date = null;
        that.last_available_exchange_date = null;

        // INIT
        that.init();
    };

    ExchangeDesiredDateScreen.prototype.init = function () {
        var that = this;

        that.__initDateInput();
    };

    ExchangeDesiredDateScreen.prototype.isValid = function () {
        var that = this;

        if (that.$input_date_desired_segment.val().length === 0 ||
            that.$input_date_desired_segment.data('value') === undefined ||
            that.$input_date_desired_segment.data('value').length === 0
        ) {
            that.$input_date_desired_segment_wrapper.addClass(that.class.error).find('.' + that.class.error).text(that.locales.date_not_selected);
            return false;
        }

        return true;
    };

    ExchangeDesiredDateScreen.prototype.getData = function () {
        return {
            value: this.$input_date_desired_segment.data('value')
        };
    };

    ExchangeDesiredDateScreen.prototype.showError = function () {
        $.uiModal({
            html: this.modals['desired_segments_for_date_not_found']
        });
    };

    /**
     * @private
     */
    ExchangeDesiredDateScreen.prototype.__initDateInput = function () {
        var that = this;

        that.ui_calendar_input = $.uiCalendarInput({
            $date_first_input: that.$input_date_desired_segment,
            month_first: $.sa.server_datetime,
            month_count: 12,
            title: that.locales.select_date,
            show_bottom_button_ow: false,
            first_enabled_date: that.origin_departure_date,
            onCalendarInit: function () {
                that.$exchange_form.css('min-height', that.$exchange_form.outerHeight() + that.$calendar_wrapper.outerHeight() + 'px');
                $.sa.$window.resize();
            },
            onFinish: function (calendar) {
                that.$exchange_form.css('min-height', '');
                if (calendar.$date_first_input.val().length) {
                    calendar.$date_first_input.parent('label').removeClass(that.class.error);
                }
            },
            onDateFormat: function (date) {
                return dayjs(date).locale($.sa.current_locale_config.code).format('D MMMM YYYY');
            },
            onDateFirstInputHighlight: function () {
                that.__updateCalendar();
            }
        });
    };

    ExchangeDesiredDateScreen.prototype.__updateCalendar = function () {
        var that = this;

        if (!that.direction || that.calendar_data || that.request_started) {
            return null;
        }
        var origin = that.direction.departure_metropolitan_code || that.direction.departure_airport_code,
            destination = that.direction.arrival_metropolitan_code || that.direction.arrival_airport_code;

        that.request_started = true;

        // if data for labels is already stored just set stored labels and do not send request
        if (that.__hasCalendarDataFor(origin, destination)) {
            that.__setCalendarDayModifiers(origin, destination);
            return null;
        }

        var _processResponseError = function (message = '', data = null) {
            var error_text = message || 'Calendar day labels: error response.';
            $.sa.error(error_text);
            if (data) {
                $.sa.error(data);
            }
        };

        var _onDone = function (response, request_data) {
            if (that.__isResponseSuccessful(response) && that.__isResponseNotEmpty(response)) {
                var data = response.data;
                // save into component property
                that.__saveCalendarData(data);
                that.__setCalendarDayModifiers(request_data['origin'], request_data['destination']);
            } else {
                if (!that.__isResponseSuccessful(response)) {
                    _processResponseError('Calendar Prices: error response.', response.errors);
                } else if (!that.__isResponseNotEmpty(response)) {
                    _processResponseError('Calendar Prices: response data is empty.')
                }
            }
        };

        var _onFail = function (jqXHR) {
            _processResponseError(`Calendar Prices error response: ${jqXHR.status} ${jqXHR.statusText}.`, jqXHR.responseText);
        };

        // Route Prices
        that.__requestCalendarData(origin, destination, {
            onDone: _onDone,
            onFail: _onFail
        });

    };

    ExchangeDesiredDateScreen.prototype.__isResponseSuccessful = function (response) {
        return response && response.status === 'ok';
    };

    ExchangeDesiredDateScreen.prototype.__isResponseNotEmpty = function (response) {
        return response && response.data;
    };

    ExchangeDesiredDateScreen.prototype.__saveCalendarDayLabelsData = function (labels) {
        var that = this;

        if (null !== that.calendar_data && typeof that.calendar_data === 'object') {
            Object.assign(that.calendar_data, labels);
        } else {
            that.calendar_data = labels;
        }
    };

    ExchangeDesiredDateScreen.prototype.__setCalendarDayModifiers = function (origin, destination) {
        var that = this,
            calendar_data = that.__getCalendarDataFor(origin, destination);

        // if default ui_calendar is not initialized
        if (false === that.__isCalendarInited()) {
            return;
        }

        ui_calendar = that.ui_calendar_input.ui_calendar;
        if (!calendar_data) {
            ui_calendar.updateDays({all: {modifiers: ['inactive']}}); // set all days inactive
        } else {
            ui_calendar.updateDays(calendar_data);
        }
    };

    ExchangeDesiredDateScreen.prototype.__requestCalendarData = function (origin, destination, callbacks = {}) {
        if (!origin.length || !destination.length) {
            return;
        }

        var that = this,
            request_data = {
                origin: origin,
                destination: destination
            },
            onDone = (callbacks['onDone'] || function () {
            }),
            onFail = (callbacks['onFail'] || function () {
            });

        $.ajax({
            url: $.sa.build_url('search/calendar'),
            method: 'POST',
            async: true,
            data: request_data,
            dataType: 'json'
        }).done(function (response) {
            onDone(response, request_data);
            that.request_started = false;
        }).fail(function (jqXHR, textStatus, errorThrown) {
            onFail(jqXHR, textStatus, errorThrown);
        });
    };

    ExchangeDesiredDateScreen.prototype.__getCalendarDataFor = function (origin, destination) {
        var that = this;

        if (false === that.__hasCalendarDataFor(origin, destination)) {
            return null;
        }
        return that.calendar_data[`${origin}-${destination}`];
    };

    ExchangeDesiredDateScreen.prototype.__saveCalendarData = function (calendar_data) {
        var that = this;

        if (null !== that.calendar_data && typeof that.calendar_data === 'object') {
            Object.assign(that.calendar_data, calendar_data);
        } else {
            that.calendar_data = calendar_data;
        }
    };

    ExchangeDesiredDateScreen.prototype.__hasCalendarDataFor = function (origin, destination) {
        var that = this;

        if (
            null === that.calendar_data ||
            !origin.length || !destination.length
        ) {
            return false;
        }

        return that.calendar_data.hasOwnProperty(`${origin}-${destination}`);
    };

    ExchangeDesiredDateScreen.prototype.__isCalendarInited = function () {
        var that = this;

        if (null === that.ui_calendar_input) {
            return false;
        }

        return null !== that.ui_calendar_input.ui_calendar;
    };

    ExchangeDesiredDateScreen.prototype.__updateDirection = function (direction) {
        var that = this;

        if (that.direction) {
            that.$departure_city.text(direction.departure_city_name);
            that.$departure_airport.text(direction.departure_airport_code);
            that.$arrival_city.text(direction.arrival_city_name);
            that.$arrival_airport.text(direction.arrival_airport_code);
            that.$trip_arrows_icon.addClass(that.class.hidden);
            that.$trip_arrow_icon.removeClass(that.class.hidden);
        }
    };

    // EVENTS

    ExchangeDesiredDateScreen.prototype.beforeUnload = function () {
        var that = this;

        that.$input_date_desired_segment.prop(that.attribute.disabled, true);
    };

    ExchangeDesiredDateScreen.prototype.beforeLoad = function (data) {
        var that = this;

        that.first_available_exchange_date = data.first_available_exchange_date || null;
        that.last_available_exchange_date = data.last_available_exchange_date || null;

        if (null !== that.ui_calendar_input) {
            that.ui_calendar_input.first_enabled_date = that.first_available_exchange_date;
            that.ui_calendar_input.last_enabled_date = that.last_available_exchange_date;
        }
    };

    ExchangeDesiredDateScreen.prototype.afterLoad = function (direction) {
        var that = this;

        that.direction = direction;
        that.$input_date_desired_segment.prop(that.attribute.disabled, false);

        that.__updateDirection(direction);
        that.__updateCalendar();
    };

    return ExchangeDesiredDateScreen;
})($);
